import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./fonts.css";
import "./styles.css";
import { capturePlatformLaunch } from "./platform-launch";
import { VkPlayBootstrap } from "./VkPlayBootstrap";
import { VkGamesBootstrap } from "./VkGamesBootstrap";

const root = document.getElementById("root");
if (!root) throw new Error("Game root element is missing");
const launch = capturePlatformLaunch(window.location, window.history);
createRoot(root).render(
  launch.kind === "vkplay" ? (
    <VkPlayBootstrap launchParams={launch.launchParams} />
  ) : launch.kind === "vkgames" ? (
    <VkGamesBootstrap launchParams={launch.launchParams} />
  ) : (
    <App />
  ),
);
